module.exports = __webpack_public_path__ + "img/page.1d29de1a.png";